import { newE2EPage } from '@stencil/core/testing';

describe('jackery-field', () => {
  it('renders', async () => {
    const page = await newE2EPage();
    await page.setContent('<jackery-field></jackery-field>');

    const element = await page.find('jackery-field');
    expect(element).toHaveClass('hydrated');
  });
});
